// @flow

export const SET_USER = "set_user";
export const SET_DRIVER_GROUP = "set_driver_group";
export const TRANSFER_RIDE = "transfer_ride";
